/**
 * LokiWeakened.js
 * The LokiWeakened Enemy class
 */

import { Game } from "pixi_core";
import { BubbleColor, EnemyAbilities, GameEvents } from "../Constants";
import { Enemy } from "./Enemy";

export class LokiWeakened extends Enemy {
    /**
     * @public
     * @param {String} enemyName
     * @param {Object} enemyData
     * @param {Number} index
     * @param {Boolean} [summoned] - Summoned by an ability
     */
    constructor(enemyName, enemyData, index, summoned) {
        super(enemyName, enemyData, index, summoned);

        const probAddRandomLine = Game.utils.assertNumber(enemyData.ProbAddRandomLine, 1);
        const probAddRandom = Game.utils.assertNumber(enemyData.ProbAddRandom, 1);

        // Ability choices
        this._abilityChoices.addChoice(EnemyAbilities.eADD_RANDOM_LINE, probAddRandomLine);
        this._abilityChoices.addChoice(EnemyAbilities.eMIMIC, probAddRandom);
    }

    /**
     * @protected
     * @override
     * @param {EnemyAbilities} abilityName
     * @param {{x: Number, y: Number}} startPos
     */
    _useAbility(abilityName, startPos) {
        switch (abilityName) {
            case EnemyAbilities.eADD_RANDOM_LINE:
                Game.fire(GameEvents.eGAME_ABILITY_ADD_RANDOM_LINE, this._nbAddedLines, startPos, this._onAbilityCompleted.bind(this));
                break;
            case EnemyAbilities.eMIMIC:
                let addBubbleData = {
                    nbBubbles: this._nbBubblesAdd,
                    color: BubbleColor.eMIMIC,
                    startPos: startPos,
                    dodgeFirst: false,
                    callback: this._onAbilityCompleted.bind(this)
                };
                Game.fire(GameEvents.eGAME_ABILITY_ADD_BUBBLE, addBubbleData);
                break;
            default:
                console.error("[LokiWeakened._useAbility] Invalid ability name : " + abilityName);
                this._chooseNextAction();
        }
    }
}
